var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"text-orange leading-normal"},[_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"cursor-pointer",on:{"click":item.onClick}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }